import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

function TextAreaInput({
  value,
  onChange,
  disabled,
  readOnly,
  maxLength,
  errored,
  password,
  id,
  margin,
  placeholder,
}) {
  const onChangeHandler = useCallback(
    (e) => {
      const newValue = e.target.value;
      if (!readOnly && (!maxLength || newValue.length <= maxLength)) {
        onChange(e, newValue);
      }
    },
    [maxLength, onChange, readOnly],
  );
  const type = password ? 'password' : 'text';
  return (
    <TextField
      id={id || 'outlined-multiline-flexible'}
      value={value || ''}
      onChange={onChangeHandler}
      disabled={disabled}
      error={errored}
      readOnly={readOnly}
      type={type}
      margin={margin}
      fullWidth
      placeholder={placeholder}
      multiline
    />

  );
}
TextAreaInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  maxLength: PropTypes.number,
  errored: PropTypes.bool,
  password: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
  placeholder: PropTypes.string,
};

TextAreaInput.defaultProps = {
  id: null,
  value: '',
  disabled: false,
  readOnly: false,
  maxLength: 0,
  errored: false,
  password: false,
  margin: 'dense',
  placeholder: null,
};

export default memo(TextAreaInput);
